"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("./users");
exports.workflowDetailData = graphql_tag_1.default `
  fragment workflowDetailData on Workflow {
    id
    name
    emailServiceProvider {
      id
      name
      displayType
      resourceUrl
      integrationType
      type
    }
    email {
      id
      emailNumber
      resourceUrl
      creatingUser {
        ...basicUserDetailData
      }
    }
    archived
    campaignFromName
    campaignFromEmailAddress
    campaignDefaultSubjectLine
    campaignReplyToEmailAddress
    campaignListID
    campaignSubjectLineSource
    schedulingLabel
    days
    time
    everyday
    sendProof
    requireApproval
    minutesBeforeRunToSendProof
    resourceUrl
    usersToSendProofsTo {
      ...basicUserDetailData
    }
    usersThatCanApprove {
      ...basicUserDetailData
    }
    runs {
      id
    }
  }
  ${users_1.basicUserDetailData}
`;
//# sourceMappingURL=workflows.js.map